// The command palette triggers these without knowing where the New menu lives
export const DRIVE_EVENTS = {
  newFolder: 'drive:new-folder',
  uploadFiles: 'drive:upload-files',
  uploadFolder: 'drive:upload-folder',
};
